var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgStarIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "StarIcon_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle 145122",
  transform: "translate(786 965)",
  fill: "#f96506",
  d: "M0 0h24v24H0z"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "UI-home-center-icon-24px",
  transform: "translate(-786 -965)",
  clipPath: "url(#StarIcon_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M798 984.455l-6.384 3.855a.94.94 0 01-.521.112 1.13 1.13 0 01-.467-.166.883.883 0 01-.345-.4.747.747 0 01-.02-.56l1.7-7.226-5.617-4.873a.906.906 0 01-.313-.462.744.744 0 01.032-.516 1.1 1.1 0 01.291-.4 1.014 1.014 0 01.494-.21l7.412-.646 2.891-6.844a.814.814 0 01.343-.419 1 1 0 01.506-.128 1 1 0 01.506.128.814.814 0 01.343.419l2.891 6.844 7.412.646a1.014 1.014 0 01.494.21 1.1 1.1 0 01.291.4.744.744 0 01.032.516.906.906 0 01-.313.462l-5.617 4.873 1.7 7.226a.747.747 0 01-.02.56.883.883 0 01-.345.4 1.13 1.13 0 01-.467.166.94.94 0 01-.521-.112z",
  fill: "#f96506"
}))));
export default __webpack_public_path__ + "static/StarIcon.7a30f1e4a7746559e21d210917ddc306.svg";
export { SvgStarIcon as ReactComponent };